import { Nullable } from 'types/common';
import { MemberCloset } from 'types/member/memberCloset';
import { AxiosError } from 'axios';

export interface MemberClosetState {
  memberCloset: MemberCloset;
  loading: boolean;
  error: Nullable<AxiosError>;
}

export const memberClosetSliceInitialState: MemberClosetState = {
  memberCloset: {
    accessibleGroups: [],
  },
  loading: false,
  error: null,
};
